import Choices from 'choices.js';

require('@nathanvda/cocoon');

import * as AutoKana from 'vanilla-autokana';

window.AutoKana = AutoKana;

require('packs/commons/validation');
import { msEmailDomains } from 'packs/commons/validation';

$(function () {
  // 使途を追加するボタン
  $(document)
    .on('cocoon:after-insert', '#js-detail_area', function (e, insertedItem) {
      initNewUsage();
      modifyList();
      $(insertedItem)
        .find('.js-other_amount_input')
        .rules('add', {
          required: true,
          number: true,
          min: 500,
          max: 999999,
          messages: {
            required: '金額を入力してください',
            number: '金額は半角数字で入力してください',
            min: '金額は500以上の値にしてください',
            max: '金額は999,999以下の値にしてください',
          },
        });
    })
    .on('cocoon:after-remove', '#js-detail_area', modifyList);

  // 使途の増減ボタンの表示条件
  function modifyList() {
    const detailCount = $('.nested-fields').length;
    const maxDetailCount = $('.js-usage_select:first option').length;

    if (detailCount <= 1) {
      $('.js-detail_delete_button').hide();
    }
    if (detailCount >= maxDetailCount) {
      $('#js-detail_add_button').hide();
    }
    if (2 <= detailCount && detailCount < maxDetailCount) {
      $('.js-detail_delete_button').show();
      $('#js-detail_add_button').show();
    }
    uniqueUsage();
  }

  modifyList();

  $(document).on('change', '.js-usage_select', function () {
    uniqueUsage();
  });

  $(document).on('click', '#js-credit_card_detail_dialog_button', function () {
    $('#js-credit_card_detail_dialog_background').fadeIn('fast');
    $('#js-credit_card_detail_dialog').fadeIn('fast').css('display', 'flex');
  });

  $(document).on('click', '#js-delivery_notice_dialog_button', function () {
    $('#js-delivery_notice_dialog_background').fadeIn('fast');
    $('#js-delivery_notice_dialog').fadeIn('fast').css('display', 'flex');
  });

  $(document).on('click', '.js-dialog_background,.js-dialog_close_button', function () {
    $('.js-dialog_background').fadeOut('fast');
    $('.js-dialog').fadeOut('fast');
  });

  $(document).on('click', '.js-privacy_policy_label', function () {
    if ($('#js-privacy-policy').prop('checked')) {
      $(this).addClass('checked');
    } else {
      $(this).removeClass('checked');
    }
  });

  // 使途を新規追加した場合の初期選択肢
  function initNewUsage() {
    const selectedUsages = $('.js-usage_select:not(:last)')
      .map(function (index, select) {
        return select.value;
      })
      .get();
    $('.js-usage_select:last option').each(function (index, option) {
      if (!selectedUsages.includes(option.value)) {
        option.selected = true;
        return false;
      }
    });
    $('.js-detail-area:last .js-amount_select[value=3000]').prop('checked', true);
    $('.js-detail-area:last input[type=hidden][name$="[amount_for_select]"]').val(3000);
    $('.js-amount_hidden:last').val(3000);
  }

  // 使途の選択肢の重複不可の処理
  function uniqueUsage() {
    const selectedUsages = $('.js-usage_select')
      .map(function (index, select) {
        return select.value;
      })
      .get();
    $('.js-usage_select option').prop('disabled', false);
    $('.js-usage_select').each(function (index, select) {
      $(select)
        .find('option')
        .each(function (i, option) {
          if ($(option).prop('selected')) {
            return;
          }
          if (selectedUsages.includes(option.value)) {
            $(option).prop('disabled', true);
          }
        });
    });
  }

  // 金額選択と入力の処理
  $(document).on('change', '.js-amount_select', function () {
    const area = $(this).parents('.js-amount_area');
    const value = $(this).val();
    if (value === 'amount_other_for_select') {
      // その他の金額選択時
      const otherAmount = area.find('.js-other_amount_input');
      otherAmount.prop('disabled', false);
      area.find('.js-amount_hidden').val(otherAmount.val());
    } else {
      const otherAmount = area.find('.js-other_amount_input');
      const otherAmountValue = otherAmount.val();
      otherAmount.prop('disabled', true);
      // エラーがある場合に回避するため一瞬適正な値を格納
      otherAmount.val(500);
      otherAmount.valid();
      otherAmount.val(otherAmountValue);
      area.find('.js-amount_hidden').val(value);
    }
    validateDonationAmountLimit();
  });

  // 画面表示時にその他金額が選択されていたときの初期表示をアクティブにする対応
  $('.js-amount_select[value=amount_other_for_select]:checked').each(function () {
    const area = $(this).parents('.js-amount_area');
    const otherAmount = area.find('.js-other_amount_input');
    otherAmount.prop('disabled', false);
    area.find('.js-amount_hidden').val(otherAmount.val());
  });

  // その他金額を入力したときの処理
  $(document).on('change', '.js-other_amount_input', function () {
    const area = $(this).parents('.js-amount_area');
    area.find('.js-amount_hidden').val($(this).val());
    validateDonationAmountLimit();
  });

  // 寄付金額の合計チェック
  function validateDonationAmountLimit() {
    const totalAmount = $('.js-amount_hidden')
      .get()
      .reduce((acc, hidden) => acc + parseInt(hidden.value), 0);
    if (totalAmount > 999999) {
      $('#js-donation-total-amount-error').show();
      return false;
    } else {
      $('#js-donation-total-amount-error').hide();
      return true;
    }
  }

  // 名前入力のカタカナ補完
  AutoKana.bind('#donation_last_name', '#donation_last_name_kana', { katakana: true });
  AutoKana.bind('#donation_first_name', '#donation_first_name_kana', { katakana: true });

  // 電話番号の入力補完(ハイフン除去)
  $(document).on('change', '#donation_tel', function () {
    $(this).val($(this).val().replaceAll('-', ''));
  });

  // 送付物の選択による住所の必須/任意切り替え
  let isAddressRequired = true;
  $(document).on('change', '#js-posting-input-group input[type=radio]', function () {
    const addressInputs = $('.js-address-input-label');
    if ($('#donation_receipt_kind_post').prop('checked') || $('#donation_active_report_kind_post').prop('checked') || $('#donation_direct_mail_kind_post').prop('checked')) {
      isAddressRequired = true;
      addressInputs.removeClass('form-optional-icon');
      addressInputs.addClass('form-required-icon');
      addressInputs.text('必須');
    } else {
      isAddressRequired = false;
      addressInputs.removeClass('form-required-icon');
      addressInputs.addClass('form-optional-icon');
      addressInputs.text('任意');
    }
  });
  $('#js-posting-input-group input[type=radio]').change();
  // 住所が必須かを返す
  const checkAddressRequired = function () {
    return isAddressRequired;
  };

  // 郵便番号の入力補完
  $(document).on('input', '#donation_postal_code', function () {
    var postalCode = $(this).val().replaceAll('-', '');
    if (postalCode.length <= 6) {
      return;
    }

    new YubinBango.Core(postalCode, function (address) {
      $('#donation_address1').val(address.region).valid();
      $('#donation_address2')
        .val(address.locality + address.street)
        .valid();
    });
  });

  // 確認ボタン
  $(document).on('click', '#js-confirm-button', function () {
    if (validateDonationAmountLimit() && $('#js-donation-form').valid()) {
      $(window).scrollTop(0);
      setConfirmValues();
      $('#js-input-area').hide();
      $('#js-alert-dialog-area').hide();
      $('#js-confirm-area').show();
      $('#js-donation-input-step').removeClass('current');
      $('#js-donation-confirm-step').addClass('current');
      // ブラウザバック対応
      window.history.pushState({ page: 'confirm' }, null, '');
    } else {
      // エラーを画面中央に持ってくる
      const firstErrorOffset = $('label.form-error:visible:first').offset();
      const scrollTop = firstErrorOffset ? firstErrorOffset.top : 0;
      $(window).scrollTop(scrollTop - $(window).height() / 2);
    }
  });

  // 確認画面の内容を生成
  function setConfirmValues() {
    $('#js-cardno_text').text($('#cardno').val());
    $('#js-expire_text').text($('#expire_year_1i').val() + '年' + ('00' + $('#expire_month_2i').val()).slice(-2) + '月');
    $('#js-holdername_text').text($('#holdername').val());
    const birthedOnYear = $('#donation_birthed_on\\(1i\\)').val();
    if (birthedOnYear) {
      const birthedOn = birthedOnYear + '年' + $('#donation_birthed_on\\(2i\\)').val() + '月' + $('#donation_birthed_on\\(3i\\)').val() + '日';
      $('#js-birthed_on_text').text(birthedOn);
    }
    const details = $('#js-details_text');
    details.empty();
    let totalAmount = 0;
    $('.js-detail-area').each(function (i, detail) {
      const detailDom = $('<li></li>');
      detailDom.append('<p class="confirm-text" style="white-space: pre;">' + $(detail).find('.js-usage_select option:selected').text() + '</p>');
      const amount = parseInt($(detail).find('.js-amount_hidden').val());
      detailDom.append('<p class="text-bold">' + amount.toLocaleString() + '円</p>');
      details.append(detailDom);
      totalAmount += amount;
    });
    details.append($('<li class="total-amount">ご寄付合計金額:' + totalAmount.toLocaleString() + '円</li>'));
    $('#js-name_text').text($('#donation_last_name').val() + '　' + $('#donation_first_name').val());
    $('#js-name_kana_text').text($('#donation_last_name_kana').val() + '　' + $('#donation_first_name_kana').val());
    if ($('#donation_previous_donated_history').val()) {
      $('#js-previous_donated_history_text').text($('#donation_previous_donated_history option:selected').text());
    }
    $('#js-email_text').text($('#donation_email').val());
    $('#js-tel_text').text($('#donation_tel').val());
    const address = '〒' + $('#donation_postal_code').val() + '\n' + $('#donation_address1').val() + $('#donation_address2').val() + $('#donation_address3').val() + $('#donation_address4').val();
    $('#js-address_text').text(address);
    $('#js-receipt_kind_text').text($('label[for=' + $('input[name="donation[receipt_kind]"]:checked').prop('id') + ']').text());
    $('#js-active_report_kind_text').text($('label[for=' + $('input[name="donation[active_report_kind]"]:checked').prop('id') + ']').text());
    $('#js-direct_mail_kind_text').text($('label[for=' + $('input[name="donation[direct_mail_kind]"]:checked').prop('id') + ']').text());
    $('#js-mail_news_kind_text').text($('label[for=' + $('input[name="donation[mail_news_kind]"]:checked').prop('id') + ']').text());
    $('#js-is_mypage_requested_text').text($('label[for=' + $('input[name="donation[is_mypage_requested]"]:checked').prop('id') + ']').text());
    $('#js-privacy_policy_text').text($('#js-privacy-policy').prop('checked') ? '同意する' : '同意しない');
  }

  // 戻るボタン
  $(document).on('click', '#js-back-button', function () {
    $(window).scrollTop(0);
    $('#js-confirm-area').hide();
    $('#js-input-area').show();
    $('#js-donation-input-step').addClass('current');
    $('#js-donation-confirm-step').removeClass('current');
    // ブラウザバック対応
    window.history.pushState({ page: 'input' }, '', '');
  });

  // 送信ボタン
  $(document).on('click', '#js-submit-button', async function () {
    $('.p-loading-modal').addClass('-shown');
    $('#js-submit-button').prop('disabled', true);
    // reCAPTCHAのトークン更新
    const tokenInput = $('#g-recaptcha-response-data-credit-card-donation');
    if (tokenInput && typeof window.executeRecaptchaForCreditCardDonationAsync === 'function') {
      const token = await window.executeRecaptchaForCreditCardDonationAsync();
      tokenInput.val(token);
    }

    $(this).prop('disabled', true);

    // クレジットカードの処理
    Multipayment.init(process.env.GMO_CARD_SHOP_ID);
    Multipayment.getToken(
      {
        cardno: $('#cardno').val(),
        expire: $('#expire_year_1i').val() + ('00' + $('#expire_month_2i').val()).slice(-2),
        securitycode: $('#securitycode').val(),
        holdername: $('#holdername').val(),
      },
      function (result) {
        if (result.resultCode === '000') {
          $('#donation_token').val(result.tokenObject.token);
          // クレカ情報は送信しない
          $('#cardno').prop('disabled', true).val('');
          $('#expire_year_1i').prop('disabled', true).val('');
          $('#expire_month_2i').prop('disabled', true).val('');
          $('#securitycode').prop('disabled', true).val('');
          $('#holdername').prop('disabled', true).val('');
          $('#js-donation-form').submit();
        } else {
          $('.p-loading-modal').removeClass('-shown');
          // エラー表示は適当
          alert('クレジットカード情報が正しくないです。err_no: ' + result.resultCode);
          $('#js-confirm-submit-button').prop('disabled', false);
          $('#js-submit-button').prop('disabled', false);
        }
      },
    );
  });

  // バリデーション
  $('#js-donation-form').validate({
    errorClass: 'form-error',
    highlight: function (element) {
      $(element).addClass('has-error');
    },
    unhighlight: function (element) {
      $(element).removeClass('has-error');
    },
    groups: {
      birthedOnGroup: 'donation[birthed_on(1i)] donation[birthed_on(2i)] donation[birthed_on(3i)]',
    },
    rules: {
      'donation[donation_details_attributes][0][amount_other_for_select]': {
        required: true,
        number: true,
        min: 500,
        max: 999999,
      },
      'donation[donation_details_attributes][1][amount_other_for_select]': {
        required: true,
        number: true,
        min: 500,
        max: 999999,
      },
      'donation[donation_details_attributes][2][amount_other_for_select]': {
        required: true,
        number: true,
        min: 500,
        max: 999999,
      },
      'donation[donation_details_attributes][3][amount_other_for_select]': {
        required: true,
        number: true,
        min: 500,
        max: 999999,
      },
      'donation[donation_details_attributes][4][amount_other_for_select]': {
        required: true,
        number: true,
        min: 500,
        max: 999999,
      },
      cardno: {
        required: true,
        digits: true,
        rangelength: [14, 16],
      },
      'expire[month(2i)]': {
        required: true,
        digits: true,
      },
      'expire[year(1i)]': {
        required: true,
        digits: true,
      },
      securitycode: {
        required: true,
        digits: true,
        rangelength: [3, 4],
      },
      holdername: {
        required: true,
        alphabet: true,
        maxlength: 50,
      },
      'donation[last_name]': {
        required: true,
        maxlength: 50,
      },
      'donation[first_name]': {
        required: true,
        maxlength: 50,
      },
      'donation[last_name_kana]': {
        required: true,
        maxlength: 100,
        katakana: true,
      },
      'donation[first_name_kana]': {
        required: true,
        maxlength: 100,
        katakana: true,
      },
      'donation[birthed_on(1i)]': {
        allOrNothing: '.js-birthed-on',
      },
      'donation[birthed_on(2i)]': {
        allOrNothing: '.js-birthed-on',
      },
      'donation[birthed_on(3i)]': {
        allOrNothing: '.js-birthed-on',
      },
      'donation[email]': {
        required: true,
        email: true,
        withoutMicrosoftDomains: true,
        maxlength: 255,
      },
      'donation[email_confirmation]': {
        required: true,
        email: true,
        withoutMicrosoftDomains: true,
        maxlength: 255,
        equalTo: '#donation_email',
      },
      'donation[tel]': {
        jpPhoneNumber: true,
        maxlength: 20,
      },
      'donation[postal_code]': {
        required: checkAddressRequired,
        postalCode: true,
        maxlength: 10,
      },
      'donation[address1]': {
        required: checkAddressRequired,
      },
      'donation[address2]': {
        required: checkAddressRequired,
        maxlength: 50,
      },
      'donation[address3]': {
        required: checkAddressRequired,
        maxlength: 255,
      },
      'donation[address4]': {
        maxlength: 255,
      },
      'donation[privacy_policy]': {
        required: true,
      },
    },
    messages: {
      'donation[donation_details_attributes][0][amount_other_for_select]': {
        required: '金額を入力してください',
        number: '金額は半角数字で入力してください',
        min: '金額は500以上の値にしてください',
        max: '金額は999,999以下の値にしてください',
        donationAmountLimit: '寄付金額の合計は999,999円以下で入力してください',
      },
      'donation[donation_details_attributes][1][amount_other_for_select]': {
        required: '金額を入力してください',
        number: '金額は半角数字で入力してください',
        min: '金額は500以上の値にしてください',
        max: '金額は999,999以下の値にしてください',
        donationAmountLimit: '寄付金額の合計は999,999円以下で入力してください',
      },
      'donation[donation_details_attributes][2][amount_other_for_select]': {
        required: '金額を入力してください',
        number: '金額は半角数字で入力してください',
        min: '金額は500以上の値にしてください',
        max: '金額は999,999以下の値にしてください',
        donationAmountLimit: '寄付金額の合計は999,999円以下で入力してください',
      },
      'donation[donation_details_attributes][3][amount_other_for_select]': {
        required: '金額を入力してください',
        number: '金額は半角数字で入力してください',
        min: '金額は500以上の値にしてください',
        max: '金額は999,999以下の値にしてください',
        donationAmountLimit: '寄付金額の合計は999,999円以下で入力してください',
      },
      'donation[donation_details_attributes][4][amount_other_for_select]': {
        required: '金額を入力してください',
        number: '金額は半角数字で入力してください',
        min: '金額は500以上の値にしてください',
        max: '金額は999,999以下の値にしてください',
        donationAmountLimit: '寄付金額の合計は999,999円以下で入力してください',
      },
      cardno: {
        required: 'カード番号を入力してください',
        digits: 'カード番号は半角数字のみで入力してください',
        rangelength: 'カード番号の桁数が正しくありません',
        maxlength: 'カード番号の桁数が正しくありません',
      },
      'expire[month(2i)]': {
        required: '有効期限（月）を入力してください',
        digits: '有効期限（月）は数字のみで入力してください',
      },
      'expire[year(1i)]': {
        required: '有効期限（年）を入力してください',
        digits: '有効期限（年）は数字のみで入力してください',
      },
      securitycode: {
        required: 'セキュリティコードを入力してください',
        digits: 'セキュリティコードは数字のみで入力してください',
        rangelength: 'セキュリティコードは3桁または4桁で入力してください',
      },
      holdername: {
        required: 'カード名義を入力してください',
        alphabet: 'カード名義は半角英字のみで入力してください',
        maxlength: 'カード名義は50文字以内で入力してください',
      },
      'donation[last_name]': {
        required: '姓を入力してください',
        maxlength: '姓は50文字以内で入力してください',
      },
      'donation[first_name]': {
        required: '名を入力してください',
        maxlength: '名は50文字以内で入力してください',
      },
      'donation[last_name_kana]': {
        required: 'セイを入力してください',
        maxlength: 'セイは100文字以内で入力してください',
        katakana: 'セイはカタカナで入力してください',
      },
      'donation[first_name_kana]': {
        required: 'メイを入力してください',
        maxlength: 'メイは100文字以内で入力してください',
        katakana: 'メイはカタカナで入力してください',
      },
      'donation[birthed_on(1i)]': {
        allOrNothing: '生年月日は年月日すべて入力してください',
      },
      'donation[birthed_on(2i)]': {
        allOrNothing: '生年月日は年月日すべて入力してください',
      },
      'donation[birthed_on(3i)]': {
        allOrNothing: '生年月日は年月日すべて入力してください',
      },
      'donation[email]': {
        required: 'メールアドレスを入力してください',
        email: 'メールアドレス形式で入力してください',
        withoutMicrosoftDomains: `メールアドレスには${msEmailDomains.join('、')}のメールアドレスは使用できません。`,
        maxlength: 'メールアドレスは255文字以内で入力してください',
      },
      'donation[email_confirmation]': {
        required: 'メールアドレス(確認用)を入力してください',
        email: 'メールアドレス形式で入力してください',
        withoutMicrosoftDomains: `メールアドレス(確認用)には${msEmailDomains.join('、')}のメールアドレスは使用できません。`,
        maxlength: 'メールアドレス(確認用)は255文字以内で入力してください',
        equalTo: 'メールアドレスが一致しません',
      },
      'donation[tel]': {
        jpPhoneNumber: 'ハイフン抜きの電話番号形式で入力してください',
        maxlength: '電話番号は20文字以内で入力してください',
      },
      'donation[postal_code]': {
        required: '郵便番号を入力してください',
        postalCode: '郵便番号形式で入力してください',
        maxlength: '郵便番号は10文字以内で入力してください',
      },
      'donation[address1]': {
        required: '都道府県を入力してください',
      },
      'donation[address2]': {
        required: '市区町村を入力してください',
        maxlength: '市区町村は50文字以内で入力してください',
      },
      'donation[address3]': {
        required: '丁目番地を入力してください',
        maxlength: '丁目番地は255文字以内で入力してください',
      },
      'donation[address4]': {
        maxlength: '建物名・部屋番号は255文字以内で入力してください',
      },
      'donation[privacy_policy]': {
        required: 'プライバシーポリシーに同意してください',
      },
    },
  });

  // ブラウザ履歴での移動対応
  $(window).on('popstate', function (e) {
    const state = e.originalEvent.state;
    if (state) {
      if (state.page === 'confirm') {
        $('#js-input-area').hide();
        $('#js-alert-dialog-area').hide();
        $('#js-confirm-area').show();
        $('#js-donation-input-step').removeClass('current');
        $('#js-donation-confirm-step').addClass('current');
      } else {
        $('#js-confirm-area').hide();
        $('#js-input-area').show();
        $('#js-donation-input-step').addClass('current');
        $('#js-donation-confirm-step').removeClass('current');
      }
    }
  });

  // ブラウザバック対応
  window.history.replaceState({ page: 'input' }, '', '');
});
